export const getOutboundSipTrunkUrl = (locationId: string, agentId: string) =>
  `business/locations/${locationId}/agents/${agentId}/outbound_sip_trunk`;
